import { render, staticRenderFns } from "./AllPep.vue?vue&type=template&id=5af722a7&scoped=true&"
import script from "./AllPep.vue?vue&type=script&lang=js&"
export * from "./AllPep.vue?vue&type=script&lang=js&"
import style0 from "./AllPep.vue?vue&type=style&index=0&id=5af722a7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af722a7",
  null
  
)

export default component.exports